export const rules = [
  { id: 5, label: "Rule 1", desc: "1 point above/below the control limits" },
  {
    id: 6,
    label: "Rule 2",
    desc: "9 points in a row on same side of centerline",
  },
  {
    id: 7,
    label: "Rule 3",
    desc: "6 points in a row increasing or decreasing",
  },
  {
    id: 13,
    label: "Rule 4",
    desc: "14 points in a row alternating up and down",
  },
  { id: 14, label: "Rule 5", desc: "2 of 3 points above/below warning limits" },
];

export const limitMethods = [
  {
    value: "calculated_mean_std_dev",
    label: "Calculated Average +/- n standard deviations",
  },
  {
    value: "target_mean_std_dev",
    label: "Target Mean +/- n standard deviations",
  },
  {
    value: "target_mean_and_limits",
    label: "Target Mean +/- Control Limit values",
  },
];

export const stdevMethods = [
  { value: "short_term", label: "Short Term" },
  { value: "long_term", label: "Long Term" },
];

export const boxCoxOptions = [
  { value: "lambda_none", label: "λ = 1 (no transformation)" },
  { value: "lambda_ln", label: "λ = 0 (ln)" },
  { value: "lambda_square_root", label: "λ = 0.5 (square root)" },
  { value: "lambda_optimal", label: "Optimal λ" },
  { value: "lambda_rounded", label: "Rounded λ" },
  { value: "lambda_specified", label: "User Specified" },
];

export const specLimits = [
  { value: "6", label: "IPL-Alert" },
  { value: "7", label: "IPL-Action" },
  { value: "8", label: "IPL-Accept" },
  { value: "13", label: "IPM" },
  { value: "9", label: "Spec-Release" },
  { value: "10", label: "Spec-Stability" },
  { value: "11", label: "AQL" },
  { value: "12", label: "Internal - Release" },
  { value: "14", label: "IPC" },
];
